import { COMPANY_CONFIG } from '../../../constants/companyConfig';
import ReviewCartAlternate from './reviewCartAlternate';
import ReviewCartDefault from './reviewCartDefault';

const ReviewCartNode = (props) => {
  const useAlternate = COMPANY_CONFIG.features?.customNodeHandling;
  return useAlternate ? (
    <ReviewCartAlternate {...props} />
  ) : (
    <ReviewCartDefault {...props} />
  );
};

export default ReviewCartNode;
